export const generate = (length: number) => {
  let text = "";
  const POSSIBLE = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const possible_len = POSSIBLE.length;

  for (let i = 0; i < length; i++) {
    text += POSSIBLE.charAt(Math.floor(Math.random() * possible_len));
  }

  return text;
};
